import { GenIcon } from '../helpers/IconBase.es.js';

const FormatTextRightOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.1818 12.3636H20.1818",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.9091 15.6364L20.1818 12.3636L16.9091 9.09091",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 5H21",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 19.7273H21",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 14.8182H7.90909",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 9.90909H7.90909",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { FormatTextRightOutlined };
